import { getMicroserviceBaseContext } from '../../../constants/api-routing';

// Microservice module contexts for v2 API URL files
export const ADMIN_CONTEXT = getMicroserviceBaseContext('admin');
export const ROLEPLAY_CONTEXT = getMicroserviceBaseContext('roleplay');
export const CHAT_CONTEXT = getMicroserviceBaseContext('chat');
export const EVALUATION_CONTEXT = getMicroserviceBaseContext('evaluation');
export const AUTH_CONTEXT = getMicroserviceBaseContext('auth');
export const KNOWLEDGE_CHECK_CONTEXT = getMicroserviceBaseContext('knowledge-check');

// Module-specific contexts consumed by v2 URL definitions
export const BASE_CONTEXT_V2_ROLEPLAY = ROLEPLAY_CONTEXT;
export const BASE_CONTEXT_V2_DOCTORS = ADMIN_CONTEXT;
export const BASE_CONTEXT_V2_USER_FEEDBACK = EVALUATION_CONTEXT;
export const BASE_CONTEXT_V2_ADMIN = ADMIN_CONTEXT;
export const BASE_CONTEXT_V2_CHAT = CHAT_CONTEXT;
export const BASE_CONTEXT_V2_AUTH = AUTH_CONTEXT;
